var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "onboarding" }, [
    _c(
      "ul",
      { staticClass: "onboarding-steps" },
      _vm._l(_vm.stati, function (s) {
        return _c("li", { key: s, class: { active: s == _vm.stato } }, [
          _c("span", [
            _c("i", [_vm._v(_vm._s(_vm._f("statoLavorazioneDescBreve")(s)))]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }